// Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com
// See license file.

import type { InjectionKey, Ref } from "vue";

export type ColumnMode = "Empty" | "Normal" | "Extended";

export const registerKey = Symbol() as InjectionKey<
  (id: String, state: Ref<ColumnMode>) => number
>;

export const navigationKey = Symbol() as InjectionKey<String>;
export const openSecondaryViewKey = Symbol() as InjectionKey<
  (id: String) => void
>;
export const closeSecondaryViewKey = Symbol() as InjectionKey<
  (id: String) => void
>;
